import { FC } from 'react';

import {
  RoleList as SharedRoleList,
  RoleListProps as SharedRoleListProps,
} from '@/shared/modules/role-board/components/role-list';

import { isOwnerRole } from '../common';

export const SYSTEM_ROLE_TOOLTIP =
  'Default role. Its built-in permissions are fixed — duplicate it to customise.';
export const OWNER_ROLE_TOOLTIP =
  "The Owner role can't be edited, duplicated, reset or deleted, and can only be removed from someone by that person.";

export type RoleListProps = Omit<SharedRoleListProps, 'lockTooltip'>;

/**
 * The entity plane's lock-tooltip resolver (Owner vs. every other system
 * role) over the plane-agnostic `RoleList` shared with the Gamma board
 * (GP-3853 Task 11) — see `@/shared/modules/role-board/components/role-list`.
 */
export const RoleList: FC<RoleListProps> = (props) => (
  <SharedRoleList
    {...props}
    lockTooltip={(role) => (isOwnerRole(role) ? OWNER_ROLE_TOOLTIP : SYSTEM_ROLE_TOOLTIP)}
  />
);
